import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Area Spline chart type
 * Extends the base chart configuration
 */
export const areasplineChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'areaspline'
    },
    plotOptions: {
        areaspline: {
            lineWidth: 1,
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            },
            fillOpacity: 0.5,
            states: {
                hover: {
                    lineWidth: 2
                }
            }
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
    }
} as Options);